import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get targets() {
    return ["saveButton", "savedTag", "selectedList", "existingList", "newList", "existingListsAlert"]
  }

  static get values() {
    return { email: String, attributes: Object, alreadyTriggered: Boolean }
  }

  save(event) {
    event.preventDefault()
    const leadAttributes = event.detail.attributes || event.params.attributes
    const sourceSlug = leadAttributes.source_slug || "undefined"

    if (this.saveButtonHidden()) {
      return
    } // Don't save if the button is hidden. This should block browser API usage
    if (this.alreadyTriggeredValue === true) {
      return
    } // Don't save if the save is already triggered (this is to prevent double clicks)

    // Get the selected list ID from the selectedList target
    if (!this.hasSavedTagTarget) {
      if (this.existingListTarget.checked) {
        leadAttributes.leads_list_id = this.selectedListTarget.value
      } else if (this.newListTarget.checked) {
        leadAttributes.leads_list_id = event.detail.list_id
      }
    }

    this.alreadyTriggeredValue = true
    fetch(App.api.leadCreate(), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(leadAttributes),
    })
      .then((response) => {
        this.alreadyTriggeredValue = false
        if (!response.ok) {
          throw response.json()
        }

        return response.json()
      })
      .then((json) => {
        this.dispatch("saved", { detail: { lead: json.data } })
        this._updateSavedButton(json.data.leads_list.id, json.data.leads_list.name)
        App.analytics.ga4_track(`leads_saved_${sourceSlug}`)
      })
      .catch((error) => {
        this.dispatch("error")

        error.then((data) => {
          if (data.errors[0].code !== 422) {
            App.displayFlash("danger", i18n.t("js.back.lead_save.error"))
          } else if (data.errors[0].id === "duplicated_entry") {
            App.displayFlash("danger", i18n.t("js.back.lead_save.already_saved"))
          } else {
            App.displayFlash("danger", data.errors[0].details)
          }

          this.exists()
        })

        this.alreadyTriggeredValue = false
      })
  }

  saveButtonHidden() {
    this.saveButtonTarget.classList.contains("d-none")
  }

  exists(event) {
    const leadEmail = event?.detail?.lead
    if (leadEmail && leadEmail !== this.emailValue) {
      return
    }

    fetch(App.api.leadExist(encodeURIComponent(this.emailValue)))
      .then((response) => {
        if (!response.ok) {
          throw new Error(response.status)
        }

        return response.json()
      })
      .then((json) => {
        if (json.data.id) {
          this._updateSavedButton(json.data.leads_list_id, json.data.leads_list_name)
        } else {
          this.saveButtonTarget.classList.remove("d-none")
          this.savedTagTarget.classList.add("d-none")
          this.alreadyTriggeredValue = false
        }
      })
  }

  _updateSavedButton(id, name) {
    if (this.hasSavedTagTarget) {
      this.saveButtonTarget.classList.add("d-none")
      this.savedTagTarget.classList.remove("d-none")
      this.savedTagTarget.href = `/leads?leads_list_id=${id}`
      this.savedTagTarget.dataset.toggle = "tooltip"
      this.savedTagTarget.title = i18n.t("js.back.domain_search.lead_save.saved_tooltip", { name: name })
      this.alreadyTriggeredValue = true

      new bootstrap.Tooltip(this.savedTagTarget)
    }
  }
}
